import { API } from "aws-amplify";
import _ from 'lodash';

export class ViewpointDao {
  private API_NAME = "Viewpoint360API";

  async getScoredChoices(packageId: string, viewpointId: string, query?: any): Promise<any> {
    let path = `/core/scoring/choices/${packageId}/${viewpointId}`;
    let myInit: any = { // OPTIONAL
      headers: {},
      queryStringParameters: {},
    };
    if (query.hasOwnProperty('pageSize')) {
      myInit.queryStringParameters.pageSize = query.pageSize;
    }
    if (query.hasOwnProperty('choiceId')) {
      myInit.queryStringParameters.choiceId = query.choiceId;
    }
    console.log('[ ViewpointDao > getScoredChoices() ]');
    console.log(myInit);
    return API.get(this.API_NAME, path, myInit);
  }

  async getChoices(packageId: string): Promise<any> {
    let path = `/choices/${packageId}`;
    return API.get(this.API_NAME, path, {});
  }

  async getFavorites(packageId: string, viewpointId: string, query?: any): Promise<any> {
    let path = `/core/selected/choices/${packageId}/${viewpointId}/favourite`;
    let myInit: any = { // OPTIONAL
      headers: {},
      queryStringParameters: {},
    };
    if (query.hasOwnProperty('pageSize')) {
      myInit.queryStringParameters.pageSize = query.pageSize;
    }
    console.log('[ ViewpointDao > getFavorites() ]');
    console.log(myInit);
    return API.get(this.API_NAME, path, myInit);
  }

  async addFavoriteToViewpoint(packageId: string, viewpointId: string, choiceId: string): Promise<any> {
    let path = `/core/selected/choices/${packageId}/${viewpointId}/favourite/${choiceId}`;
    return API.post(this.API_NAME, path, {});
  }

  async removeFavoriteFromViewpoint(packageId: string, viewpointId: string, choiceId: string): Promise<any> {
    let path = `/core/selected/choices/${packageId}/${viewpointId}/favourite/${choiceId}`;
    return API.del(this.API_NAME, path, {});
  }

  async createViewpointFromViewpoint(packageId: string, viewpointId: string, name?: string, description?: string): Promise<any> {
    let path = `/choices/${packageId}`;
    if (viewpointId) {
      path = path + "/" + viewpointId
    }
    let myInit = {
      body: {
        name: name,
        description: description
      }
    };
    return API.post(this.API_NAME, path, myInit);
  }

  async createViewpoint(packageId: string, name?: string, description?: string): Promise<any> {
    let path = `/core/viewpoint/${packageId}`;
    let myInit = {
      body: {
        name: name,
        description: description
      }
    };
    return API.post(this.API_NAME, path, myInit);
  }

  async editViewpoint(packageId: string, viewpointId: string, name: any, description: any): Promise<any> {
    let path = `/core/viewpoint/${packageId}/${viewpointId}`;
    let myInit = {
      body: {
        name: name,
        description: description
      }
    };
    return API.post(this.API_NAME, path, myInit);
  }

  async deleteViewpoint(packageId: string, viewpointId: string): Promise<any> {
    let path = `/core/viewpoint/${packageId}/${viewpointId}`;
    return API.del(this.API_NAME, path, {});
  }

  async getFactors(packageId: string, viewpointId: string): Promise<any> {
    let path = `/core/factors/${packageId}/${viewpointId}`;
    return API.get(this.API_NAME, path, {})
  }

  async updateFactor(packageId: string, viewpointId: string, factor: any): Promise<any> {
    let path = `/core/factors/${packageId}/${viewpointId}/${factor.id}`;
    let myInit = {
      body: factor
    };
    return API.post(this.API_NAME, path, myInit);
  }

  async updateFactorWeights(packageId: string, viewpointId: string, factors: any): Promise<any> {
    let path = `/core/factors/weight/${packageId}/${viewpointId}`;
    let factorArray: any[] = [];
    console.log('*************************');
    console.log(factors);
    if (factors.length) {
      factorArray = _.map(factors);
      factors = factorArray.reduce((map, obj) => (map[obj.id] = obj, map), {});
    }
    console.log(factors);
    let myInit = {
      body: {
        factors: factors
      }
    };
    return API.post(this.API_NAME, path, myInit);
  }

  async deleteFactor(packageId: string, viewpointId: string, factorId: string): Promise<any> {
    let path = `/core/factors/${packageId}/${viewpointId}/${factorId}`;
    return API.del(this.API_NAME, path, {});
  }

  async deleteChoice(packageId: string, choiceId: string): Promise<any> {
    let path = `/choices/${packageId}/${choiceId}`;
    return API.del(this.API_NAME, path, {});
  }

  async createTeam(packageId: string, name: string, description: string): Promise<any> {
    let path = `/core/team/${packageId}`;
    let myInit = {
      body: {
        name: name,
        description: description
      }
    };
    return API.post(this.API_NAME, path, myInit);
  }

  async editTeam(packageId: string, teamId: string, name: any, description: any): Promise<any> {
    let path = `/core/team/${packageId}/${teamId}`;
    let myInit = {
      body: {
        name: name,
        description: description
      }
    };
    return API.post(this.API_NAME, path, myInit);
  }

  async deleteTeam(packageId: string, teamId: string): Promise<any> {
    let path = `/core/team/${packageId}/${teamId}`;
    return API.del(this.API_NAME, path, {});
  }

  async addViewpointToTeam(packageId: string, viewpointId: string, teamId: string): Promise<any> {
    let path = `/core/team/${packageId}/${teamId}/viewpoints/${viewpointId}`;
    return API.post(this.API_NAME, path, {});
  }

  async removeViewpointFromTeam(packageId: string, viewpointId: string, teamId: string): Promise<any> {
    let path = `/core/team/${packageId}/${teamId}/viewpoints/${viewpointId}`;
    return API.del(this.API_NAME, path, {});
  }

  // Accepts an Array of Viewpoints and returns a Promise containing an array of Promises
  async addViewpointsToTeam(team: any, viewpoints: any[]): Promise<any> {
    return Promise.all(
      viewpoints.map(async (viewpoint: any) => {
        return this.addViewpointToTeam(team.packageId, viewpoint, team.teamId);
      })
    );
  }

  // Accepts an Array of Viewpoints and returns a Promise containing an array of Promises
  async removeViewpointsFromTeam(team: any, viewpoints: any[]): Promise<any> {
    return Promise.all(
      viewpoints.map(async (viewpoint: any) => {
        return this.removeViewpointFromTeam(team.packageId, viewpoint, team.teamId);
      })
    );
  }

}

